import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import './FlexIconRow.scss';


const propTypes ={
    img1: PropTypes.string,
    img2: PropTypes.string,
    img3: PropTypes.string,
    img4: PropTypes.string,
    img5: PropTypes.string,
    img6: PropTypes.string,

};

export default class FlexIconRow extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        const {breakpoint, img1, img2, img3, img4, img5, img6} = this.props;

        return(
            <section>
                <div className='icon--contailner'>
                    <MediaQuery query="(max-width: 769px)">
                        <div className='icons--holder'>
                            <div className='first-two'>
                                <div className='tile-icon-container'>
                                    <img src={img1} />
                                </div>
                                <div className='tile-icon-container'>
                                    <img src={img2} />
                                </div>
                            </div>
                            <div className='second-two'>
                                <div className='tile-icon-container'>
                                    <img src={img3} />
                                </div>
                                <div className='tile-icon-container'>
                                    <img src={img4} />
                                </div>
                            </div>
                            <div className='third-two'>
                                <div className='tile-icon-container'>
                                    <img src={img5} />
                                </div>
                                <div className='tile-icon-container'>
                                    <img src={img6} />
                                </div>
                            </div>
                        </div>
                    </MediaQuery>
                    <MediaQuery query="(min-width: 770px)">
                        <div className='icons--holder'>
                            <div className='first-three'>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img1}/>
                                </div>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img2}/>
                                </div>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img3}/>
                                </div>
                            </div>
                            <div className='second-three'>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img4}/>
                                </div>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img5}/>
                                </div>
                                <div className='tile-icon-container'>
                                    <img className='f-icon-img' src={img6}/>
                                </div>
                            </div>
                        </div>
                    </MediaQuery>
                </div>
            </section>
        );

    }
}

FlexIconRow.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/FlexIconRow/index.js